'use client';

import { faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import Drawer from 'react-bottom-drawer';
import BlogPageContents from './BlogPageContents';

function BlogPageMobileNav() {
    const [isVisible, setIsVisible] = useState(false);

    return (
        <>
            <div
                className="fixed bottom-0 flex w-full cursor-pointer items-center justify-center bg-white p-4 font-demi shadow-md lg:hidden"
                onClick={() => setIsVisible(true)}
            >
                <span className="mr-2">Table of contents</span>
                <FontAwesomeIcon icon={faChevronUp} />
            </div>
            {/* Bottom mobile drawer*/}
            <Drawer
                isVisible={isVisible}
                onClose={() => setIsVisible(false)}
                hideScrollbars={true}
                className="p-1.5"
            >
                <BlogPageContents setIsVisible={setIsVisible} />
            </Drawer>
        </>
    );
}

export default BlogPageMobileNav;
